import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as Sentry from "@sentry/react";

const apiBaseUrl = process.env.REACT_APP_BASE_URL as string;
const hostedUrl = process.env.REACT_APP_HOSTED_URL as string;
Sentry.init({
  dsn: "https://84eff5744a037d81db83d4ff329b14eb@o4508765907714048.ingest.us.sentry.io/4508765909876736",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    // "localhost",
    new RegExp(`^${apiBaseUrl.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&")}`),
    new RegExp(`^${hostedUrl.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&")}`),
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  enabled: process.env.NODE_ENV !== "development",
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
